import React, { useState, useEffect, useCallback } from 'react';
import './Hero.css';
import heroimage1 from '../Images/shona2.jpeg';
import heroimage2 from '../Images/banner2.jpeg';

const slides = [
  {
    image: heroimage1,
    heading: 'Willkommen bei VegBox',
    subheading: 'Höchste Qualität, auf Sie zugeschnitten, jetzt bestellen',
    cta: 'Jetzt bestellen',
  },
  {
    image: heroimage2,
    heading: 'Frisch gebacken für Sie',
    subheading: 'Torten, Cupcakes & Leckereien für Ihre besonderen Anlässe',
    cta: 'Jetzt bestellen',
  },
  // Add more slides here as needed
];

const HeroDe = () => {
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % slides.length);
  }, []);

  useEffect(() => {
    if (paused) return;
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [paused, next]);

  return (
    <div
      className="hero-carousel"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      {slides.map((slide, idx) => (
        <div
          key={idx}
          className={`hero-slide ${idx === current ? 'active' : ''}`}
        >
          <div className="hero-slide-inner">
            <div className="hero-text">
              <h2>{slide.heading}</h2>
              <h3>{slide.subheading}</h3>
              <button
                className="cta"
                onClick={() =>
                  document
                    .getElementById('products')
                    ?.scrollIntoView({ behavior: 'smooth' })
                }
              >
                {slide.cta}
              </button>
            </div>
            <div className="hero-image-wrap">
              <img src={slide.image} alt={slide.heading} className="hero-img" />
            </div>
          </div>
        </div>
      ))}

      {/* Dot indicators */}
      <div className="hero-dots">
        {slides.map((_, idx) => (
          <button
            key={idx}
            className={`hero-dot ${idx === current ? 'active' : ''}`}
            onClick={() => setCurrent(idx)}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroDe;
